import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'


import App from './App';

import "./assets/css/meanmenu.css"
import "./assets/css/navber.css"
import "./assets/css/style.css"
import "./assets/css/responsive.css"
import "./assets/css/fontawesome.all.min.css"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

